import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { MentoringReportsListingModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-grid-model';
import { MentoringReportsModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-data-model';
import { MentoringReportsGridPostParams } from 'common/models/page-models/reports/mentoring-reports/mentoring-grid-params';
import { MentoringChartsModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-charts-model';


@Injectable({
  providedIn: 'root'
})
export class MentoringReportsDataService extends GridDataService<MentoringReportsListingModel, MentoringReportsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.fetchMentoringData, http, ss);
  }

  createInstance(): MentoringReportsListingModel {
    return new MentoringReportsListingModel();
  }

  getDeleteUrl() {
    return '';
  }

  getGridParams(param): GridPostParams {
    return new MentoringReportsGridPostParams();
  }

  override transformDataModel(data: any[], param: any) {
    super.transformDataModel(data, param);
    if (data.hasOwnProperty(param)) {

      data[param].forEach(element => {
        // const avgScore = new Headers('Average Score', 'avgScore', false, false, 'text');
        element.y1q1Doc = !element.signedurl_year1_quarter1_doc || element.signedurl_year1_quarter1_doc === null ? '-' :  element.signedurl_year1_quarter1_doc;
        element.y1q2Doc = !element.signedurl_year1_quarter2_doc || element.signedurl_year1_quarter2_doc === null ? '-' :  element.signedurl_year1_quarter2_doc;
        element.y1q3Doc = !element.signedurl_year1_quarter3_doc || element.signedurl_year1_quarter3_doc === null ? '-' :  element.signedurl_year1_quarter3_doc;
        element.y1q4Doc = !element.signedurl_year1_quarter4_doc || element.signedurl_year1_quarter4_doc === null ? '-' :  element.signedurl_year1_quarter4_doc;
        element.y2q1Doc = !element.signedurl_year2_quarter1_doc || element.signedurl_year2_quarter1_doc === null ? '-' :  element.signedurl_year2_quarter1_doc;
        element.y2q2Doc = !element.signedurl_year2_quarter2_doc || element.signedurl_year2_quarter2_doc === null ? '-' :  element.signedurl_year2_quarter2_doc;
        element.y2q3Doc = !element.signedurl_year2_quarter3_doc || element.signedurl_year2_quarter3_doc === null ? '-' :  element.signedurl_year2_quarter3_doc;
        element.y2q4Doc = !element.signedurl_year2_quarter4_doc || element.signedurl_year2_quarter4_doc === null ? '-' :  element.signedurl_year2_quarter4_doc;
        element.y3q1Doc = !element.signedurl_year3_quarter1_doc || element.signedurl_year3_quarter1_doc === null ? '-' :  element.signedurl_year3_quarter1_doc;
        element.y3q2Doc = !element.signedurl_year3_quarter2_doc || element.signedurl_year3_quarter2_doc === null ? '-' :  element.signedurl_year3_quarter2_doc;
        element.y3q3Doc = !element.signedurl_year3_quarter3_doc || element.signedurl_year3_quarter3_doc === null ? '-' :  element.signedurl_year3_quarter3_doc;
        element.y3q4Doc = !element.signedurl_year3_quarter4_doc || element.signedurl_year3_quarter4_doc === null ? '-' :  element.signedurl_year3_quarter4_doc;
        element.y4q1Doc = !element.signedurl_year4_quarter1_doc || element.signedurl_year4_quarter1_doc === null ? '-' :  element.signedurl_year4_quarter1_doc;
        element.y4q2Doc = !element.signedurl_year4_quarter2_doc || element.signedurl_year4_quarter2_doc === null ? '-' :  element.signedurl_year4_quarter2_doc;
        element.y4q3Doc = !element.signedurl_year4_quarter3_doc || element.signedurl_year4_quarter3_doc === null ? '-' :  element.signedurl_year4_quarter3_doc;
        element.y4q4Doc = !element.signedurl_year4_quarter4_doc || element.signedurl_year4_quarter4_doc === null ? '-' :  element.signedurl_year4_quarter4_doc;

        // const totalScoreInPercentage =
        // element.avgScore = element.avgScore === 0 ? '0' : element.avgScore;
        // element.totalScoreInPercentage = element.totalScoreInPercentage === 0 ? '0' : element.totalScoreInPercentage;

      });
    } else {
      // console.log('No records found for given combination');
      this.ss.showError('No records found for given combination')
    }
    return data;
  }

  override modifyGridPostParams(queryParams) {
    let payload = this.getGridParams(queryParams);
    // console.log(queryParams)
    if (queryParams.transferData !== null) {
      payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
      payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
      payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
      payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
      payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
      payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
      payload['year_search'] = queryParams.transferData.selectedYear === null ? '' : queryParams.transferData.selectedYear;
      payload['quarter_search'] = queryParams.transferData.selectedQuarter === null ? '' : queryParams.transferData.selectedQuarter;
      payload['upload_search'] = queryParams.transferData.selectedUploadFilter === null ? '' : queryParams.transferData.selectedUploadFilter;
    }
    return payload;
  }

  override prepareChartsData(apiData) {
    const chartsModel = new MentoringChartsModel();

    const studentCount = this.countUploadedAndNotUploaded(apiData);
    const studentCountYearWise = this.countUploadedAndNotUploadedYearWise(apiData);

    // console.log(studentCount, studentCountYearWise);

    chartsModel.studentStatusChart.options = {
      chart: {
        type: 'pie',
        width: 320, // Adjust chart width
        height: 300 // Adjust chart height
      },
      credits: {
        enabled: false // Disable the Highcharts credits
      },
      title: {
        text: 'Total Students:  ' + apiData.length,
        style: {
          color: '#000000',
          fontSize: '1em',
        }
      },
      series: [
        {
          type: 'pie', // Add the type property here
          data: [
            {
              name: 'Uploaded:' + studentCount.uploadedCount,
              y: studentCount.uploadedCount,
              // y: 5,
              color: '#e6e6fa'
            },
            {
              name: 'Non-Uploaded:' + studentCount.notUploadedCount,
              y: studentCount.notUploadedCount,
              // y: 8,
              color: '#ffc0cb'
            }
          ],
          dataLabels: {
            enabled: false,
            inside: true,
            distance: 6 // Adjust the distance of labels from the slices
          }
        }
      ]
    };

    chartsModel.studentStatusChart.data = {
      uploadedData: studentCount.uploadedCount,
      uploadedColor: '#e6e6fa',
      nonUploadedData: studentCount.notUploadedCount,
      nonUploadedColor: '#ffc0cb'
    }

    chartsModel.studentStatusChartYearWise = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Uploaded Vs Not-Uploaded Year Wise',
        align: 'left'
      },
      xAxis: {
        categories: ['Year 1', 'Year 2', 'Year 3', 'Year 4'],
        crosshair: true,
        accessibility: {
          description: 'Years'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Count'
        }
      },
      tooltip: {
        valueSuffix: ''
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [
        {
          name: 'Uploaded',
          color: '#f5f5dc',
          data: [{ y: studentCountYearWise.year1.uploadedCount, color: '#f5f5dc' }, { y: studentCountYearWise.year2.uploadedCount, color: '#f5f5dc' }, { y: studentCountYearWise.year3.uploadedCount, color: '#f5f5dc' }, { y: studentCountYearWise.year4.uploadedCount, color: '#f5f5dc' }]
        },
        {
          name: 'Not Uploaded',
          color: '#ffe5b4',
          data: [{ y: studentCountYearWise.year1.notUploadedCount, color: '#ffe5b4' }, { y: studentCountYearWise.year2.notUploadedCount, color: '#ffe5b4' }, { y: studentCountYearWise.year3.notUploadedCount, color: '#ffe5b4' }, { y: studentCountYearWise.year4.notUploadedCount, color: '#ffe5b4' }]
        }
      ]
    };

    return chartsModel;
  }

  countUploadedAndNotUploaded(students) {
    let uploadedCount = 0;
    let notUploadedCount = 0;

    students.forEach(student => {
      // Check if any document key is not null
      const hasUploaded = student.year1_quarter1_doc !== null ||
        student.year1_quarter2_doc !== null ||
        student.year1_quarter3_doc !== null ||
        student.year1_quarter4_doc !== null ||
        student.year2_quarter1_doc !== null ||
        student.year2_quarter2_doc !== null ||
        student.year2_quarter3_doc !== null ||
        student.year2_quarter4_doc !== null ||
        student.year3_quarter1_doc !== null ||
        student.year3_quarter2_doc !== null ||
        student.year3_quarter3_doc !== null ||
        student.year3_quarter4_doc !== null ||
        student.year4_quarter1_doc !== null ||
        student.year4_quarter2_doc !== null ||
        student.year4_quarter3_doc !== null ||
        student.year4_quarter4_doc !== null;

      if (hasUploaded) {
        uploadedCount++;
      } else {
        notUploadedCount++;
      }
    });

    return { uploadedCount, notUploadedCount };
  }

  countUploadedAndNotUploadedYearWise(students) {
    const yearCounts = {
      year1: { uploadedCount: 0, notUploadedCount: 0 },
      year2: { uploadedCount: 0, notUploadedCount: 0 },
      year3: { uploadedCount: 0, notUploadedCount: 0 },
      year4: { uploadedCount: 0, notUploadedCount: 0 }
    };

    students.forEach(student => {
      // Year 1
      const hasUploadedYear1 = student.signedurl_year1_quarter1_doc !== null ||
        student.signedurl_year1_quarter2_doc !== null ||
        student.signedurl_year1_quarter3_doc !== null ||
        student.signedurl_year1_quarter4_doc !== null;
      if (hasUploadedYear1) {
        yearCounts.year1.uploadedCount++;
      } else {
        yearCounts.year1.notUploadedCount++;
      }

      // Year 2
      const hasUploadedYear2 = student.signedurl_year2_quarter1_doc !== null ||
        student.signedurl_year2_quarter2_doc !== null ||
        student.signedurl_year2_quarter3_doc !== null ||
        student.signedurl_year2_quarter4_doc !== null;
      if (hasUploadedYear2) {
        yearCounts.year2.uploadedCount++;
      } else {
        yearCounts.year2.notUploadedCount++;
      }

      // Year 3
      const hasUploadedYear3 = student.signedurl_year3_quarter1_doc !== null ||
        student.signedurl_year3_quarter2_doc !== null ||
        student.signedurl_year3_quarter3_doc !== null ||
        student.signedurl_year3_quarter4_doc !== null;
      if (hasUploadedYear3) {
        yearCounts.year3.uploadedCount++;
      } else {
        yearCounts.year3.notUploadedCount++;
      }

      // Year 4
      const hasUploadedYear4 = student.signedurl_year4_quarter1_doc !== null ||
        student.signedurl_year4_quarter2_doc !== null ||
        student.signedurl_year4_quarter3_doc !== null ||
        student.signedurl_year4_quarter4_doc !== null;
      if (hasUploadedYear4) {
        yearCounts.year4.uploadedCount++;
      } else {
        yearCounts.year4.notUploadedCount++;
      }
    });

    return yearCounts;
  }
}
